import { formatGraphQlDate } from '../../helpers/date';
import { companyFilter } from '../../apollo/reactive-variables/filters';
import dayjs from '../../config/dayjs';

export const getSelectedCompanyFilterVariables = (
  selectedCompany,
  defaultFilterDays = 14,
) => (selectedCompany
  ? {
    companyId: selectedCompany.id,
    dateIssued_Gte: null,
    dateIssued_Lte: null,
  }
  : {
    companyId: null,
    dateIssued_Gte: formatGraphQlDate(
      dayjs().subtract(defaultFilterDays, 'days'),
    ),
    dateIssued_Lte: formatGraphQlDate(dayjs()),
  });

const selectedCompanyFilter = (
  selectedCompany,
  setCustomVariables = () => {},
  defaultFilterDays = 14,
) => {
  const filters = getSelectedCompanyFilterVariables(selectedCompany, defaultFilterDays);
  setCustomVariables((prev) => ({ ...prev, ...filters }));
  companyFilter({
    selectedCompany,
    filters,
  });
};

export const getInitialCompanyFilterVariables = (defaultFilterProps) => (
  defaultFilterProps.showCompanyIssuerFilter
    ? getSelectedCompanyFilterVariables(
      companyFilter().selectedCompany,
      defaultFilterProps.defaultFilterDays,
    )
    : {}
);

export default selectedCompanyFilter;
